// extracted by mini-css-extract-plugin
export var icon = "_5j-1";
export var subtext = "_5j-0";